module.exports = __webpack_public_path__ + "img/logo_text.bbca4542.png";